import { BehaviorSubject, Observable, of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { PBIReport } from '@shared/models';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { tap, map } from 'rxjs/operators';

@Injectable()
export class PBIReportService extends ApiService<PBIReport> {
  _reports: BehaviorSubject<PBIReport[]> = new BehaviorSubject([]);

  constructor(http: HttpClient) {
    super(http);
  }

  setReports(reports: PBIReport[]) {
    this._reports.next(reports);
  }

  fetchReports(): Observable<PBIReport[]> {
    return this.get({ url: 'power-bi/reports' }).pipe(tap((reports) => this.setReports(reports)));
  }

  getReportById(reportId: string): Observable<PBIReport> {
    return of(
      !!this._reports.value && this._reports.value.find((report) => report.reportId === reportId),
    );
  }

  getReports(): Observable<PBIReport[]> {
    const existingReports: PBIReport[] = this._reports.value;
    if (!!existingReports.length) {
      return of(existingReports);
    } else if (!this._reports.value || this._reports.value.length === 0) {
      return this.fetchReports().pipe(map((reports: PBIReport[]) => reports));
    }
  }
}
